import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

// url is created in kpiMixin
const getKpi = (url, params = {}) => {
  return clientHTTP.getAll(url, params)
}

const getKpiAlarms = (gateway, alarms, startDate, endDate) => {
  return clientHTTP
    .getAll(
      getLinkHref(gateway, 'gatewayEvents'),
      { type: alarms, startDate: startDate, endDate: endDate }
    )
}

export default {
  getKpi,
  getKpiAlarms
}
